module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/settings/info-icon-b28c905497c1921e9452e7adb7aa385d.svg";